import { AfterContentInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SemControlComponent } from '../sem-control/sem-control.component';

@Component({
    selector: 'sem-snapshots',
    templateUrl: './sem-snapshots.component.html',
    styleUrls: ['./sem-snapshots.component.css'],
    standalone: false
})
export class SemSnapshotsComponent extends SemControlComponent implements OnInit, AfterContentInit, OnDestroy {

  @Input() contentbody: string = "";
  
  innerHtml: string = "";

  ngAfterContentInit(): void {
  }

  ngOnDestroy(): void {
  }

  setSnapshot(body:any){
    if(body == "0"){
      this.formService.broadDynamicFormChange("0");
      return;
    }

    this.formService.broadDynamicFormChange(body);
  }
}